import { supabase } from './supabaseClient';

const BASE_URL = (process.env.REACT_APP_SKINNY_SUPABASE_URL || '').replace(/\/+$/, '');
const MEMBERSHIPS_ENDPOINT = BASE_URL ? `${BASE_URL}/functions/v1/user-memberships` : '';
const REDIRECT_FLAG = 'SKINNY_HOMELESS_REDIRECTED';
const SUPPRESS_FLAG = 'SKINNY_HOMELESS_SUPPRESS';

let installed = false;
let checking = false;
let originalFetchRef = null;

function shouldSkip(url) {
  if (!url) return false;
  return url.includes('/user-memberships') || url.includes('/invites-auto-accept');
}

function extractUrl(input) {
  if (typeof input === 'string') return input;
  if (input && typeof input === 'object') {
    if (input.url) return input.url;
  }
  return '';
}

async function confirmHomeless() {
  if (checking || !MEMBERSHIPS_ENDPOINT) return;
  checking = true;
  try {
    let token = (await supabase.auth.getSession()).data.session?.access_token || '';
    if (!token) return;
    sessionStorage.setItem(SUPPRESS_FLAG, '1');
    const headers = { 'content-type': 'application/json', Authorization: `Bearer ${token}` };
    const resp = await originalFetchRef(MEMBERSHIPS_ENDPOINT, { method: 'POST', headers, body: '{}' });
    sessionStorage.removeItem(SUPPRESS_FLAG);
    if (!resp.ok) return;
    const data = await resp.json();
    const list = Array.isArray(data?.memberships) ? data.memberships : [];
    if (list.length === 0) {
      sessionStorage.setItem(REDIRECT_FLAG, '1');
      window.location.assign('/no-sites');
    }
  } catch (_) {
    // ignore
  } finally {
    sessionStorage.removeItem(SUPPRESS_FLAG);
    checking = false;
  }
}

export function installHomelessInterceptor() {
  if (installed) return;
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') return;
  installed = true;
  originalFetchRef = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetchRef(...args);
    try {
      if (
        response &&
        response.status === 403 &&
        !sessionStorage.getItem(SUPPRESS_FLAG) &&
        window.location.pathname !== '/no-sites'
      ) {
        const url = extractUrl(args[0]);
        if (!shouldSkip(url)) {
          confirmHomeless();
        }
      }
    } catch (_) {
      // ignore interceptor errors
    }
    return response;
  };
}

export function clearHomelessRedirectFlag() {
  try { sessionStorage.removeItem(REDIRECT_FLAG); } catch (_) { /* ignore */ }
  try { sessionStorage.removeItem(SUPPRESS_FLAG); } catch (_) { /* ignore */ }
}

